import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import DeliveryFunctionNetworkInterfaceCreateDialog from 'routes/DeliveryFunctionNetworkInterface/containers/DeliveryFunctionNetworkInterfaceCreateDialog';
import SipSettingCreate from './containers/SipSettingCreate';
import SipSettingEdit from './containers/SipSettingEdit';
import SipSettingView from './containers/SipSettingView';
import { SYSTEM_CONFIGURATION_ROUTE, SIP_SETTING, SYSTEM } from '../../constants';

interface Props {
}

const SipSetting: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${SIP_SETTING}`}>
        <SipSettingView />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${SIP_SETTING}/create`}>
        <SipSettingCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${SIP_SETTING}/edit`}>
        <SipSettingEdit />
      </Route>
      <DeliveryFunctionNetworkInterfaceCreateDialog />
    </Fragment>
  );
};

export default SipSetting;
